module.exports = __webpack_public_path__ + "static/media/toaster.f836f08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toaster.png
// module id = 1063
// module chunks = 0